import { render, staticRenderFns } from "./product_user.vue?vue&type=template&id=591742f6&scoped=true&"
import script from "./product_user.vue?vue&type=script&lang=js&"
export * from "./product_user.vue?vue&type=script&lang=js&"
import style0 from "./product_user.vue?vue&type=style&index=0&id=591742f6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "591742f6",
  null
  
)

export default component.exports